<template>
  <div class="body">
    <header_index style="background-color: #fff;"
                  v-if="!isMobile()"></header_index>
    <div class="box"
         v-if="!isMobile()">
      <div class="boxTop">
        <h1>机构培训证书查询中心</h1>
        <el-input placeholder="请输入项目名称"
                  class="topInput"
                  v-model="name">
          <el-button slot="append"
                     @click="toSearch"
                     icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <div class="boxMid">
        <div class="bmPro">
          <div class="proBox"
               v-for="(item,index) in list"
               :style="index%2==0?'margin-left:0':''"
               @click="toDetail(item.id)"
               :key="index">
            <img :src="item.showImageUrl"
                 alt="">
            <div class="title">{{item.name}}</div>
          </div>
          <div v-show="list.length==0">未找到符合条件的项目</div>
        </div>
        <!-- <pagination v-if="page.total>0"
                    isNum
                    :total="page.total"
                    :limit="page.pageSize"
                    :page="page.currentPage"
                    @page-change="pageChange"></pagination> -->
      </div>
    </div>
    <div class="mbox"
         v-else>
      <div class="boxTop">
        <h2 style="text-align:center">机构培训证书查询中心</h2>
        <el-input placeholder="请输入项目名称"
                  class="topInput"
                  size="medium"
                  v-model="name">
          <el-button slot="append"
                     @click="toSearch"
                     icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <van-list v-model="loading"
                :finished="finished"
                finished-text=""
                @load="GetscrollOpusList">
        <div class="mbrow"
             v-for="(item,index) in list"
             @click="toDetail(item.id)"
             :key="index">
          <img :src="item.showImageUrl"
               alt="">
          <div class="title">{{item.name}}</div>
        </div>
      </van-list>
    </div>
    <footer_index v-if="!isMobile()"></footer_index>
  </div>
</template>

<script>
import header_index from '../home/header_index';
import footer_index from '../home/footer_index';
export default {
  data () {
    return {
      name: '',
      page: {
        total: 0,
        pageSize: 4,
        currentPage: 1
      },
      list: [],
      loading: false,
      finished: false,
    };
  },
  components: {
    header_index,
    footer_index
  },
  created () {
    this.getList()
    window.addEventListener('scroll', this.scrollFn);
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.scrollFn);
  },
  methods: {
    pageChange (val) {
      if (this.page.currentPage == val) return
      this.page.currentPage = val;
      this.getList()
    },
    isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    },
    toSearch () {
      this.page.currentPage = 1;
      this.getList()
    },
    toDetail (id) {
      this.$router.push({
        name: 'queryDetail',
        query: {
          id: id
        }
      })
    },
    getList () {
      this.httphelper.post('/api/TrainingProjectApi/GetTrainingProjectInfoPageList', {
        name: this.name,
        page: this.page.currentPage,
        limit: this.page.pageSize
      }).then((res) => {
        if (res.data.code == 200) {
          this.page.total = res.data.totalcount
          this.list = res.data.data
        }
      })
    },
    getScrollTop () {
      var scrollTop = 0, bodyScrollTop = 0, documentScrollTop = 0;
      if (document.body) {
        bodyScrollTop = document.body.scrollTop;
      }
      if (document.documentElement) {
        documentScrollTop = document.documentElement.scrollTop;
      }
      scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop;
      return scrollTop;
    },
    getWindowHeight () {
      var windowHeight = 0;
      if (document.compatMode == "CSS1Compat") {
        windowHeight = document.documentElement.clientHeight;
      }
      else {
        windowHeight = document.body.clientHeight;
      }
      return windowHeight;
    },
    getScrollHeight () {
      var scrollHeight = 0, bodyScrollHeight = 0, documentScrollHeight = 0;
      if (document.body) {
        bodyScrollHeight = document.body.scrollHeight;
      }
      if (document.documentElement) {
        documentScrollHeight = document.documentElement.scrollHeight;
      }
      scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight;
      return scrollHeight;
    },
    scrollFn () {
      if ((this.getScrollTop() + this.getWindowHeight()) + 120 >= this.getScrollHeight()) {
        if (this.page.currentPage < this.page.total / this.page.pageSize) {
          this.GetscrollOpusList();
        }
      }
    },
    GetscrollOpusList () {
      this.page.currentPage++
      this.httphelper.post('/api/TrainingProjectApi/GetTrainingProjectInfoPageList', {
        name: this.name,
        page: this.page.currentPage,
        limit: this.page.pageSize
      }).then((res) => {
        if (res.data.code == 200) {
          this.list = this.list.concat(res.data.data)
          this.loading = false;
          if (this.list.length >= this.page.total) {
            this.finished = true;
          }
        }
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.body {
    // background-color: rgb(246, 246, 246);
    height: 100%;
}
.box {
    // width: 1200px;
    min-height: calc(100vh - 384px);
    .boxTop {
        display: flex;
        height: 160px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 50px;
        padding-bottom: 40px;
        background-color: #e5f2ff;
        margin-bottom: 50px;
        h2 {
            line-height: 60px;
        }
        .topInput {
            width: 700px;
            ::v-deep .el-input__inner {
                height: 40px;
            }
        }
    }
    .boxMid {
        width: 1200px;
        padding-bottom: 20px;
        margin: 0 auto;
        .bmPro {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            .proBox {
                width: 500px;
                height: 350px;
                // background-color: #fff;
                background-color: #e5f2ff;
                margin-left: 50px;
                margin-bottom: 35px;
                cursor: pointer;
                img {
                    width: 500px;
                    height: 300px;
                }
                .title {
                    font-size: 16px;
                    line-height: 32px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-align: center;
                }
            }
        }
    }
}
.mbox {
    padding: 20px 3vw;
    background-color: #e5f2ff;
    min-height: 100%;
    box-sizing: border-box;
    .boxTop {
        margin-bottom: 20px;
        margin-top: 20px;
    }
    .mbrow {
        margin-bottom: 15px;
        width: 100%;
        height: 70vw;
        background-color: #fff;
        img {
            width: 100%;
            height: 60vw;
        }
        .title {
            font-size: 14px;
            line-height: 24px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-align: center;
        }
    }
}
</style>